export function DocumentViewer({ url }) {
  return <iframe height="100%" src={url} title="Document" width="100%" />
}
